/* DC Filters v1 — /assets/dc-filters.js
   Client-side filter controller for the dc-filters.liquid section.
   Reads JSON config from the page, manages filter state in URL, toggles cards.

   URL params:
     ?ct=Espresso,Filter       coffee-type checkboxes (comma-list)
     ?origin=Ethiopia,Kenya    origin checkboxes (comma-list, "Origin: " stripped)
     ?process=Washed           processing radio (single value, "Process: " stripped)
     ?price=20-50              price range (dollars, hyphen-separated)
     ?sort_by=price-ascending  native Shopify sort (full page reload)
*/
(function(){
  'use strict';

  var root = document.querySelector('[data-dcf-root]');
  if(!root) return;

  var cfgEl = root.querySelector('[data-dcf-config]') || document.querySelector('[data-dcf-config]');
  if(!cfgEl){ console.error('[dcf] config script tag not found'); return; }
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); }
  catch(e){ console.error('[dcf] config parse failed', e); return; }

  var dims = cfg.dimensions;
  var dimByKey = {};
  var dimByParam = {};
  dims.forEach(function(d){ dimByKey[d.key]=d; dimByParam[d.param]=d; });

  // ---------- DOM refs ----------
  var grid = root.querySelector('[data-dcf-grid]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-dcf-card]'));
  var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-dcf-trigger]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-dcf-panel]'));
  var visibleCountEl = root.querySelector('[data-dcf-visible-count]');
  var emptyEl = root.querySelector('[data-dcf-empty]');
  var sortSel = root.querySelector('[data-dcf-sort]');
  var clearAllBtns = Array.prototype.slice.call(root.querySelectorAll('[data-dcf-clear-all], [data-dcf-clear-all-empty]'));
  var mobileToggle = root.querySelector('[data-dcf-mobile-toggle]');
  var trigsWrap = root.querySelector('[data-dcf-trigs-wrap]');
  var mobileCountEl = root.querySelector('[data-dcf-mobile-count]');

  // ---------- Card index ----------
  // Pre-parse each card's collection titles and price bounds into a fast lookup.
  cards.forEach(function(card){
    var raw = card.getAttribute('data-cf-c') || '';
    var titles = raw.split('|').filter(function(s){return s.length>0});
    card._dcfCollections = titles;
    card._dcfPriceMin = parseInt(card.getAttribute('data-cf-pmin'),10) || 0;
    card._dcfPriceMax = parseInt(card.getAttribute('data-cf-pmax'),10) || 0;
  });

  // ---------- State ----------
  // state[dimKey] = Array<string> for multi, single string for radio, [min,max] cents for price
  var state = {};
  dims.forEach(function(d){ state[d.key] = d.match === 'price-range' ? [null, null] : (d.multiple ? [] : ''); });

  function readUrl(){
    var p = new URLSearchParams(window.location.search);
    dims.forEach(function(d){
      var v = p.get(d.param);
      if(d.match === 'price-range'){
        if(v && /^\d*-\d*$/.test(v)){
          var parts = v.split('-');
          var lo = parts[0] === '' ? null : Math.round(parseFloat(parts[0]) * 100);
          var hi = parts[1] === '' ? null : Math.round(parseFloat(parts[1]) * 100);
          state[d.key] = [lo, hi];
        } else { state[d.key] = [null, null]; }
      } else if(d.multiple){
        state[d.key] = v ? v.split(',').filter(Boolean) : [];
      } else {
        state[d.key] = v || '';
      }
    });
  }

  function writeUrl(){
    var p = new URLSearchParams(window.location.search);
    // strip dcf params we own, keep anything else (sort_by, page, etc)
    dims.forEach(function(d){ p.delete(d.param); });
    dims.forEach(function(d){
      if(d.match === 'price-range'){
        var lo = state[d.key][0], hi = state[d.key][1];
        if(lo !== null || hi !== null){
          var loStr = lo === null ? '' : (lo/100);
          var hiStr = hi === null ? '' : (hi/100);
          p.set(d.param, loStr + '-' + hiStr);
        }
      } else if(d.multiple){
        if(state[d.key].length) p.set(d.param, state[d.key].join(','));
      } else {
        if(state[d.key]) p.set(d.param, state[d.key]);
      }
    });
    var qs = p.toString();
    var newUrl = window.location.pathname + (qs ? ('?' + qs) : '') + window.location.hash;
    window.history.replaceState(null, '', newUrl);
  }

  // ---------- UI sync from state ----------
  function syncInputs(){
    dims.forEach(function(d){
      if(d.match === 'price-range'){
        var minEl = root.querySelector('[data-dcf-input="priceMin"]');
        var maxEl = root.querySelector('[data-dcf-input="priceMax"]');
        if(minEl) minEl.value = state[d.key][0] === null ? '' : (state[d.key][0]/100);
        if(maxEl) maxEl.value = state[d.key][1] === null ? '' : (state[d.key][1]/100);
        return;
      }
      var inputs = root.querySelectorAll('[data-dcf-input="'+d.key+'"]');
      Array.prototype.forEach.call(inputs, function(i){
        if(d.multiple){
          i.checked = state[d.key].indexOf(i.value) >= 0;
        } else {
          i.checked = (state[d.key] || '') === i.value;
        }
      });
    });
  }

  // ---------- Card filter logic ----------
  // A card passes filter dimension D when:
  //   coffeeType (multi): card.collections has any selected title
  //   origin (multi):     card.collections has any "Origin: <selected>"
  //   process (single):   card.collections has "Process: <selected>" (or no selection)
  //   price:              card.priceMin <= state.priceMax AND card.priceMax >= state.priceMin
  function cardPasses(card){
    for(var i=0; i<dims.length; i++){
      var d = dims[i];
      var s = state[d.key];
      if(d.match === 'price-range'){
        var lo = s[0], hi = s[1];
        if(lo !== null && card._dcfPriceMax < lo) return false;
        if(hi !== null && card._dcfPriceMin > hi) return false;
      } else if(d.match === 'title-in'){
        if(!d.multiple || s.length === 0) continue;          // no selection = no filter
        var hit = false;
        for(var j=0; j<s.length; j++){
          if(card._dcfCollections.indexOf(s[j]) >= 0){ hit = true; break; }
        }
        if(!hit) return false;
      } else if(d.match === 'title-prefix'){
        if(d.multiple){
          if(s.length === 0) continue;
          var hit2 = false;
          for(var k=0; k<s.length; k++){
            if(card._dcfCollections.indexOf(d.prefix + s[k]) >= 0){ hit2 = true; break; }
          }
          if(!hit2) return false;
        } else {
          if(!s) continue;
          if(card._dcfCollections.indexOf(d.prefix + s) < 0) return false;
        }
      }
    }
    return true;
  }

  function activeFilterCount(){
    var n = 0;
    dims.forEach(function(d){
      if(d.match === 'price-range'){
        if(state[d.key][0] !== null || state[d.key][1] !== null) n++;
      } else if(d.multiple){
        n += state[d.key].length;
      } else if(state[d.key]){
        n++;
      }
    });
    return n;
  }

  function updateBadge(dimKey){
    var badge = root.querySelector('[data-dcf-badge="'+dimKey+'"]');
    if(!badge) return;
    var d = dimByKey[dimKey];
    var n = 0;
    if(d.match === 'price-range'){
      n = (state[d.key][0] !== null || state[d.key][1] !== null) ? 1 : 0;
    } else if(d.multiple){
      n = state[d.key].length;
    } else if(state[d.key]){
      n = 1;
    }
    if(n > 0){ badge.textContent = n; badge.hidden = false; }
    else { badge.hidden = true; }
  }

  function applyFilters(){
    var visible = 0;
    cards.forEach(function(card){
      if(cardPasses(card)){ card.classList.remove('dcf-hide'); visible++; }
      else { card.classList.add('dcf-hide'); }
    });
    if(visibleCountEl) visibleCountEl.textContent = visible;
    if(emptyEl) emptyEl.hidden = (visible !== 0);
    if(grid) grid.style.display = visible === 0 ? 'none' : '';

    var n = activeFilterCount();
    var clearBtn = root.querySelector('[data-dcf-clear-all]');
    if(clearBtn) clearBtn.hidden = (n === 0);
    if(mobileCountEl) mobileCountEl.textContent = n > 0 ? n + ' active' : '';

    dims.forEach(function(d){ updateBadge(d.key); });
  }

  // ---------- Event wiring ----------
  function closeAllPanels(except){
    panels.forEach(function(p){
      if(p === except) return;
      p.classList.remove('open');
      var key = p.getAttribute('data-dcf-panel');
      var t = root.querySelector('[data-dcf-trigger="'+key+'"]');
      if(t) t.setAttribute('aria-expanded','false');
    });
  }

  triggers.forEach(function(trig){
    trig.addEventListener('click', function(e){
      e.stopPropagation();
      var key = trig.getAttribute('data-dcf-trigger');
      var panel = root.querySelector('[data-dcf-panel="'+key+'"]');
      if(!panel) return;
      var isOpen = panel.classList.contains('open');
      closeAllPanels(panel);
      if(isOpen){ panel.classList.remove('open'); trig.setAttribute('aria-expanded','false'); }
      else { panel.classList.add('open'); trig.setAttribute('aria-expanded','true'); }
    });
  });

  // Click outside a panel closes panels
  document.addEventListener('click', function(e){
    if(!root.contains(e.target)) closeAllPanels(null);
    else if(!e.target.closest('.dcf-panel') && !e.target.closest('.dcf-trig')) closeAllPanels(null);
  });

  // Filter input changes
  root.addEventListener('change', function(e){
    var input = e.target.closest('[data-dcf-input]');
    if(!input) return;
    var key = input.getAttribute('data-dcf-input');
    if(key === 'priceMin' || key === 'priceMax'){
      // price inputs commit via the Apply button only
      return;
    }
    var d = dimByKey[key];
    if(!d) return;
    if(d.multiple){
      var checked = Array.prototype.slice.call(root.querySelectorAll('[data-dcf-input="'+key+'"]:checked'))
        .map(function(i){return i.value});
      state[d.key] = checked;
    } else {
      state[d.key] = input.value;
    }
    writeUrl();
    applyFilters();
  });

  // Price Apply button
  var priceApply = root.querySelector('[data-dcf-price-apply]');
  if(priceApply){
    priceApply.addEventListener('click', function(){
      var minEl = root.querySelector('[data-dcf-input="priceMin"]');
      var maxEl = root.querySelector('[data-dcf-input="priceMax"]');
      var lo = minEl && minEl.value !== '' ? Math.round(parseFloat(minEl.value) * 100) : null;
      var hi = maxEl && maxEl.value !== '' ? Math.round(parseFloat(maxEl.value) * 100) : null;
      if(lo !== null && isNaN(lo)) lo = null;
      if(hi !== null && isNaN(hi)) hi = null;
      state.price = [lo, hi];
      writeUrl();
      applyFilters();
      closeAllPanels(null);
    });
  }

  // Sort — native Shopify, full reload to keep server-side sort consistent
  if(sortSel){
    sortSel.addEventListener('change', function(){
      var p = new URLSearchParams(window.location.search);
      p.set('sort_by', sortSel.value);
      window.location.search = p.toString();
    });
  }

  // Clear all
  clearAllBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      dims.forEach(function(d){
        state[d.key] = d.match === 'price-range' ? [null, null] : (d.multiple ? [] : '');
      });
      writeUrl();
      syncInputs();
      applyFilters();
      closeAllPanels(null);
    });
  });

  // Mobile drawer
  if(mobileToggle && trigsWrap){
    mobileToggle.addEventListener('click', function(){
      var isOpen = trigsWrap.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if(!isOpen) closeAllPanels(null);
    });
  }

  // ---------- Bootstrap ----------
  readUrl();
  syncInputs();
  applyFilters();

  // Expose for debugging
  window.dcFilters = { state: state, applyFilters: applyFilters, cfg: cfg, cards: cards };
})();
